/* template */
<template><div class="calendar-month"><div class="calendar-month-title">{{ title }}</div><div class="calendar-month-days"><mpx-view v-for="(item, index) in (days)" :key="item.index" :style="[(item.type === 'selected' ? activeColor : '')] | transRpxStyle" :class='("calendar-month-day "+(item.isToday ? "is-today" : "")+" "+(item.type && "is-"+ item.type))' @tap="onClick(index)"><span :class='("calendar-month-topText "+(item.holidayType))' v-if="(item.supText)">{{item.supText}}</span><span class="calendar-month-text">{{ item.text }}</span><span :class="({highlight:item.subText.highlight})" class="calendar-month-subText" v-if="(item.subText && item.subText.text)">{{ item.subText.text }}</span></mpx-view></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m48f43283"}'>
.calendar-month
  &-title
    height 38px
    font-size 16px
    font-weight normal
    line-height 38px
    text-align center
    color #333
    letter-spacing 0
    background-color #F3F4F5
    font-family PingFangSC-Semibold
  &-days
    position relative
    display flex
    flex-direction row
    flex-wrap wrap
    user-select none
    padding 6px
  &-day
    position relative
    display flex
    flex-direction column
    width 14.285%
    align-items center
    justify-content center
    height 59px
    text-align center
    color #333
  &-text
    font-family PingFangSC-Medium
    font-weight normal
    font-size 16px
  &-subText
    position absolute
    left 0
    right 0
    bottom 5px
    font-size 12px
    -webkit-transform scale(0.84)
    transform-origin bottom center
    letter-spacing 0
    white-space nowrap
    color #999
    &.highlight
      color #ff5900
  &-topText
    position absolute
    left 0
    right 0
    top 5px
    font-size 12px
    -webkit-transform scale(0.84)
    transform-origin top center
    letter-spacing 0
    white-space nowrap
    color #FF5900
.is-today
  color #FF6400
.is-disabled
  color #cccccc
  cursor default
.is-selected, .is-start, .is-end, .is-start-end, .is-multiple, .is-multiple-middle, .is-multiple-selected
  position relative
  background-color #FF5900
  color #fff
  border-radius 8px
  font-family PingFangSC-Regular
  .calendar-month-subText, .calendar-month-topText
    color #fff
.is-start
  border-top-right-radius 0
  border-bottom-right-radius 0
.is-end
  border-top-left-radius 0
  border-bottom-left-radius 0
.is-multiple-middle
  border-radius 0
.is-middle
  background #FFF5F0
  border-radius 0
  color #333
.popover-calendar-wapper
  position absolute
  bottom 60px
  z-index 999
.blue-text
  color #1473ff
.text-999
  color #999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m48f43283"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./month.mpx.js?isComponent&outputPath=components%2Fmonth48f43283%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./month.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fmonth48f43283%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m48f43283"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/month48f43283/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
